module.exports = __webpack_public_path__ + "static/media/blog-2.447a2926.jpg";